
import { Component, ChangeDetectionStrategy, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { CommonModule } from '@angular/common';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-update-password',
  standalone: true,
  templateUrl: './update-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, CommonModule],
})
export class UpdatePasswordComponent {
  private authService = inject(AuthService);
  private notificationService = inject(NotificationService);
  private router = inject(Router);
  
  updateForm: FormGroup;
  isLoading = signal(false);
  errorMessage = signal<string | null>(null);
  
  showPassword = signal(false);
  showConfirmPassword = signal(false);

  constructor() {
    const fb: FormBuilder = inject(FormBuilder);
    this.updateForm = fb.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', Validators.required]
    }, { validators: this.passwordMatchValidator });
  }

  passwordMatchValidator(g: AbstractControl) {
    return g.get('password')?.value === g.get('confirmPassword')?.value
      ? null : { 'mismatch': true };
  }

  togglePassword(): void { this.showPassword.update(v => !v); }
  toggleConfirmPassword(): void { this.showConfirmPassword.update(v => !v); }

  async onSubmit(): Promise<void> {
    if (this.updateForm.invalid) return;

    this.isLoading.set(true);
    this.errorMessage.set(null);

    const { password } = this.updateForm.value;
    const result = await this.authService.updateUserPassword(password);

    if (result.success) {
      this.notificationService.showSuccess('เปลี่ยนรหัสผ่านสำเร็จ! กรุณาเข้าสู่ระบบด้วยรหัสผ่านใหม่');
      // Force logout to ensure clean state and require login with new password
      await this.authService.logout(); 
    } else {
      this.errorMessage.set(result.error || 'เกิดข้อผิดพลาดในการอัปเดตรหัสผ่าน');
      this.isLoading.set(false);
    }
  }
}
